import { ROUTE_NAME } from '@/lib/constant';
import { RouteConfig } from 'vue-router';

const routes: RouteConfig[] = [
    {
        path: '/address/list',
        name: ROUTE_NAME.ADDRESS_LIST,
        meta: {
            title: '地址管理',
        },
        component: () => import(/* webpackChunkName: "address" */ '@/pages/address/list.vue'),
    },
    {
        path: '/address/edit/:addressId?',
        name: ROUTE_NAME.ADDRESS_EDIT,
        meta: {
            title: '地址管理',
        },
        component: () => import(/* webpackChunkName: "address" */ '@/pages/address/edit.vue'),
    },
];

export default routes;
